import styled from 'styled-components'
import { rem } from 'polished'

import Group from 'components/utils/Group'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineSubwayIcon from 'LuxKit/Icons/line/LineSubwayIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'

const FallbackLogoContainer = styled(Group)`
  width: ${rem(56)};
  height: ${rem(56)};
  object-fit: contain;
  background-color: ${props => props.theme.palette.neutral.default.six};
`

type TransportLogoType = 'FLIGHT' | 'CAR_RENTAL' | 'TRAIN' | 'BUS' | 'FERRY' | 'OTHER_TRANSPORT'

interface Props {
  type: TransportLogoType
}

function TransportDefaultLogo({ type }: Props) {
  const getIcon = () => {
    switch (type) {
      case 'FLIGHT':
        return <LinePlaneDepartureIcon size="L" />
      case 'CAR_RENTAL':
        return <LineCarIcon size="L" />
      case 'TRAIN':
        return <LineSubwayIcon size="L" />
      case 'BUS':
        return <LineBusIcon size="L" />
      case 'FERRY':
        return <LineShipIcon size="L" />
      case 'OTHER_TRANSPORT':
        return <LineCarIcon size="L" />
      default:
        return <LineCarIcon size="L" />
    }
  }

  return (
    <FallbackLogoContainer direction="horizontal" horizontalAlign="center" verticalAlign="center">
      {getIcon()}
    </FallbackLogoContainer>
  )
}

export default TransportDefaultLogo
